export default __webpack_public_path__ + "5d96b93fe6a03abeea64b0816d216013.png";